// extracted by mini-css-extract-plugin
export const container = "featuredProject-module--container--193Yk";
export const projectContainer = "featuredProject-module--projectContainer--3fW7S";
export const image = "featuredProject-module--image--3ckcL";
export const title = "featuredProject-module--title--3TFsA";
export const summary = "featuredProject-module--summary--1OTcM";
export const button = "featuredProject-module--button--Z6HUj";
export const description = "featuredProject-module--description--24eHT";